/**
 * Users API Hooks
 */

import { useApiData, useAuthenticatedFetch } from './client';
import type { EdnaRole, InternalUser, UserRole } from './types';

export function useUsers() {
  return useApiData<InternalUser[]>('/internal/users');
}

export function useMyRole() {
  return useApiData<UserRole>('/internal/users/me/role');
}

export function useUserMutations() {
  const { fetchData } = useAuthenticatedFetch<InternalUser>();

  const updateRole = (userId: number, role: EdnaRole) =>
    fetchData(`/internal/users/${userId}/role`, {
      method: 'PUT',
      body: JSON.stringify({ role }),
    });

  return { updateRole };
}
